import { InputState as t } from "./components.js";
import { INPUT_CONFIG as o } from "./config.js";
const n = {
  keys: /* @__PURE__ */ new Set(),
  mouseButtons: /* @__PURE__ */ new Set(),
  mouseDeltaX: 0,
  mouseDeltaY: 0,
  scrollDelta: 0
}, s = {
  jump: {
    lastPressTime: 0,
    lastReleaseTime: 0,
    lastConsumeTime: 0,
    isPressed: !1
  },
  primary: {
    lastPressTime: 0,
    lastReleaseTime: 0,
    lastConsumeTime: 0,
    isPressed: !1
  },
  secondary: {
    lastPressTime: 0,
    lastReleaseTime: 0,
    lastConsumeTime: 0,
    isPressed: !1
  }
};
let l = null, r = null;
function d(e) {
  return e instanceof HTMLCanvasElement ? l === null || e === l : !1;
}
function p(e) {
  return e instanceof HTMLCanvasElement && e === r;
}
function y(e) {
  r && (n.keys.add(e.code), e.code === "Space" && (e.preventDefault(), s.jump.isPressed || (s.jump.lastPressTime = performance.now(), s.jump.isPressed = !0)));
}
function v(e) {
  r && (n.keys.delete(e.code), e.code === "Space" && (s.jump.lastReleaseTime = performance.now(), s.jump.isPressed = !1));
}
function E(e) {
  n.mouseButtons.add(e.button), e.button === 0 && !s.primary.isPressed ? (s.primary.lastPressTime = performance.now(), s.primary.isPressed = !0) : e.button === 2 && (e.preventDefault(), s.secondary.isPressed || (s.secondary.lastPressTime = performance.now(), s.secondary.isPressed = !0));
}
function C(e) {
  n.mouseButtons.delete(e.button), e.button === 0 ? (s.primary.lastReleaseTime = performance.now(), s.primary.isPressed = !1) : e.button === 2 && (s.secondary.lastReleaseTime = performance.now(), s.secondary.isPressed = !1);
}
function k(e) {
  n.mouseDeltaX += e.movementX, n.mouseDeltaY += e.movementY;
}
function M(e) {
  n.scrollDelta += e.deltaY * o.mouseSensitivity.scroll, e.preventDefault();
}
function b(e) {
  e.preventDefault();
}
function w(e) {
  d(e.target) && (r = e.target);
}
function T(e) {
  e.target === r && (r = null, B());
}
function P(e) {
  d(e.target) && (e.target.tabIndex = e.target.tabIndex === -1 ? 0 : e.target.tabIndex, e.target.focus(), E(e));
}
function D(e) {
  r && C(e);
}
function g(e) {
  p(e.target) && k(e);
}
function h(e) {
  p(e.target) && M(e);
}
function L(e) {
  r && b(e);
}
function x(e) {
  l = e, e === null && (r = null);
}
function I(e) {
  r = e;
}
function Y() {
  typeof window > "u" || (document.addEventListener("mousedown", P, !0), document.addEventListener("mouseup", D, !0), document.addEventListener("mousemove", g, !0), document.addEventListener("wheel", h, {
    passive: !1,
    capture: !0
  }), document.addEventListener("contextmenu", L, !0), document.addEventListener("focusin", w, !0), document.addEventListener("focusout", T, !0), window.addEventListener("keydown", y), window.addEventListener("keyup", v));
}
function A() {
  typeof window > "u" || (document.removeEventListener("mousedown", P, !0), document.removeEventListener("mouseup", D, !0), document.removeEventListener("mousemove", g, !0), document.removeEventListener("wheel", h, !0), document.removeEventListener("contextmenu", L, !0), document.removeEventListener("focusin", w, !0), document.removeEventListener("focusout", T, !0), window.removeEventListener("keydown", y), window.removeEventListener("keyup", v), l = null, r = null);
}
function f(e, u) {
  let a = 0;
  for (const i of e)
    n.keys.has(i) && (a += 1);
  for (const i of u)
    n.keys.has(i) && (a -= 1);
  return a;
}
function m(e, u) {
  const a = performance.now();
  return e.lastPressTime <= e.lastConsumeTime ? !1 : a - e.lastPressTime <= u;
}
function c(e) {
  return m(e, o.bufferWindow) ? (e.lastConsumeTime = performance.now(), !0) : !1;
}
function F(e) {
  const u = o.mouseSensitivity;
  t.moveX[e] = f(
    o.mappings.moveRight,
    o.mappings.moveLeft
  ), t.moveY[e] = f(
    o.mappings.moveForward,
    o.mappings.moveBackward
  ), t.moveZ[e] = f(
    o.mappings.moveUp,
    o.mappings.moveDown
  ), t.lookX[e] = n.mouseDeltaX * u.look, t.lookY[e] = n.mouseDeltaY * u.look, t.scrollDelta[e] = n.scrollDelta, t.jump[e] = m(
    s.jump,
    o.bufferWindow
  ) ? 1 : 0, t.primaryAction[e] = m(
    s.primary,
    o.bufferWindow
  ) ? 1 : 0, t.secondaryAction[e] = m(
    s.secondary,
    o.bufferWindow
  ) ? 1 : 0, t.leftMouse[e] = n.mouseButtons.has(0) ? 1 : 0, t.rightMouse[e] = n.mouseButtons.has(2) ? 1 : 0, t.middleMouse[e] = n.mouseButtons.has(1) ? 1 : 0, t.jumpBufferTime[e] = s.jump.lastPressTime, t.primaryBufferTime[e] = s.primary.lastPressTime, t.secondaryBufferTime[e] = s.secondary.lastPressTime;
}
function j() {
  n.mouseDeltaX = 0, n.mouseDeltaY = 0, n.scrollDelta = 0;
}
function B() {
  n.keys.clear(), n.mouseButtons.clear(), j();
  const e = performance.now();
  s.jump = {
    lastPressTime: 0,
    lastReleaseTime: e,
    lastConsumeTime: e,
    isPressed: !1
  }, s.primary = {
    lastPressTime: 0,
    lastReleaseTime: e,
    lastConsumeTime: e,
    isPressed: !1
  }, s.secondary = {
    lastPressTime: 0,
    lastReleaseTime: e,
    lastConsumeTime: e,
    isPressed: !1
  };
}
function X() {
  return c(s.jump);
}
function W() {
  return c(s.primary);
}
function U() {
  return c(s.secondary);
}
function H() {
  return r;
}
export {
  m as canConsumeAction,
  A as cleanupEventListeners,
  B as clearAllInput,
  c as consumeAction,
  X as consumeJump,
  W as consumePrimary,
  U as consumeSecondary,
  H as getFocusedCanvas,
  f as getMovementAxis,
  b as handleContextMenu,
  y as handleKeyDown,
  v as handleKeyUp,
  E as handleMouseDown,
  k as handleMouseMove,
  C as handleMouseUp,
  M as handleWheel,
  j as resetFrameDeltas,
  I as setFocusedCanvas,
  x as setTargetCanvas,
  Y as setupEventListeners,
  F as updateInputState
};
//# sourceMappingURL=utils.js.map
